/**
 * @file EmailNoticeField.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-06
 * @modified 2026-10-06
 * @description "Notice for the email (optional)" — a box on the transport send
 *              windows (driver paperwork, office summary, mills / suppliers)
 *              whose text the server puts at the top of every email the send
 *              produces, under the greeting, in a gold highlighted box
 *              (services/emailNotice.js). Empty means no box: the emails are
 *              exactly as before. Email body only — the attachments are
 *              unchanged.
 */

import React from 'react';
import Textarea from './Textarea';
import './EmailNoticeField.css';

// Kept in step with NOTICE_MAX_LENGTH in services/emailNotice.js, which caps it again.
export const EMAIL_NOTICE_MAX_LENGTH = 1000;

function EmailNoticeField({ id, value, onChange, disabled = false, many = false }) {
  return (
    <div className="email-notice-field">
      <label htmlFor={id}>Notice for the email (optional)</label>
      <Textarea id={id} rows={3} value={value} maxLength={EMAIL_NOTICE_MAX_LENGTH}
        disabled={disabled}
        placeholder="e.g. Mill closed 12–1 today — please ring ahead."
        onChange={(e) => onChange(e.target.value)} />
      <span className="email-notice-hint">
        Appears at the top of {many ? 'each' : 'the'} email, under the greeting, in a highlighted box.
        Leave empty for no notice.
      </span>
    </div>
  );
}

export default EmailNoticeField;
